import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/news`;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// GET
export const getNews = async () => {
  try {
    const response = await axios.get(`${apiUrl}/getAllNews`, {
      headers: { ...authHeaders() },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des actualités:", error);
    return [];
  }
};

export const getLatestNews = async () => {
  try {
    const response = await axios.get(`${apiUrl}/getLastThreeNews`, {
      headers: { ...authHeaders() },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des actualités:", error);
    return [];
  }
};

// POST
export const createNews = async (news) => {
  try {
    const response = await axios.post(`${apiUrl}/addNews`, news, {
      headers: { ...authHeaders() },
    });
    if (![200, 201].includes(response.status)) {
      throw new Error("Failed to add news");
    }
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout de l'actualité:", error);
    return null;
  }
};

// UPLOADS (laisser Axios gérer Content-Type; envoyer x-category: news)
export const uploadFirstImageNews = async (formData) => {
  try {
    const response = await axios.post(`${apiUrl}/uploadImage1`, formData, {
      headers: { ...authHeaders(), "x-category": "news" },
    });
    return response.data; // { filePath }
  } catch (error) {
    console.error("Erreur lors de l'upload de l'image 1 de la news :", error);
    return null;
  }
};

export const uploadSecondImageNews = async (formData) => {
  try {
    const response = await axios.post(`${apiUrl}/uploadImage2`, formData, {
      headers: { ...authHeaders(), "x-category": "news" },
    });
    return response.data; // { filePath }
  } catch (error) {
    console.error("Erreur lors de l'upload de l'image 2 de la news :", error);
    return null;
  }
};

// PUT
export const updateNews = async (id, newsData) => {
  try {
    const response = await axios.put(`${apiUrl}/updateNews/${id}`, newsData, {
      headers: { ...authHeaders() },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la mise à jour de l'actualité :",
      error.response?.data || error
    );
    throw error;
  }
};

// DELETE
export const deleteNews = async (newsId) => {
  try {
    const response = await axios.delete(`${apiUrl}/deleteNews/${newsId}`, {
      headers: { ...authHeaders() },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression de l'actualité:", error);
    return null;
  }
};
